module.exports = __webpack_public_path__ + "img/proQuest.44b42562.png";